import { getFeature } from 'Cloud/Application/FeaturesEs6';

interface FeatureProps {
    variant: 'a' | 'b' | 'c';
    tariff?: string;
}

// CLOUDWEB-18910
// Коммуникация в Чистилке при удалении файлов
export const overquotaClearDelAb: FeatureProps | undefined = getFeature('overquota-clear-del-ab');
